import { PlasticsComponent } from './components/landing-page/plastics/plastics.component';
import { LaundryShowcaseComponent } from './components/landing-page/laundry-showcase/laundry-showcase.component';
import { PlasticsShowcaseComponent } from './components/landing-page/plastics-showcase/plastics-showcase.component';
import { ConfectionsComponent } from './components/landing-page/confections/confections.component';
import { LaundryComponent } from './components/landing-page/laundry/laundry.component';
import { ConfectionsShowcaseComponent } from './components/landing-page/confections-showcase/confections-showcase.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomePageComponent } from './components/landing-page/home-page/home-page.component';
import { ProjetosComponent } from './components/landing-page/projetos/projetos.component';
import { LoginComponent } from './components/dashboard/login/login.component';
import { AuthGuard } from './shared/auth.guard';
import { LinhasDePesquisaComponent } from './components/landing-page/linhas-de-pesquisa/linhas-de-pesquisa.component';
import { PesquisadoresComponent } from './components/landing-page/pesquisadores/pesquisadores.component';
import { EventsComponent } from './components/landing-page/events/events.component';
import { ContactComponent } from './components/landing-page/contact/contact.component';
import { BibliotecaComponent } from './components/landing-page/biblioteca/biblioteca.component';
import { PainelPessoaJuridicaComponent } from './components/dashboard/pessoa-juridica/painel-pessoa-juridica/painel-pessoa-juridica.component';
import { SolicitantesResiduosComponent } from './components/dashboard/pessoa-juridica/solicitantes-residuos/solicitantes-residuos.component';
import { PainelPessoaFisicaComponent } from './components/dashboard/pessoa-fisica/painel-pessoa-fisica/painel-pessoa-fisica.component';
import { CadastroResiduosComponent } from './components/dashboard/pessoa-juridica/cadastro-residuos/cadastro-residuos.component';
import { CadastroComponent } from './components/dashboard/cadastro/cadastro.component';
import { ResetPasswordComponent } from './components/dashboard/reset-password/reset-password.component';
import { NewPasswordComponent } from './components/dashboard/reset-password/new-password/new-password.component';
import { CriaComponent } from './components/landing-page/cria/cria.component';
import { DidaticaComponent } from './components/landing-page/cria/didatica/didatica.component';
import { CriaInformacoesComponent } from './components/landing-page/cria/informacoes/informacoes.component';
import { CriaResultadosComponent } from './components/landing-page/cria/resultados/resultados.component';

const routes: Routes = [
  { path: '', component: HomePageComponent },
  { path: 'login', component: LoginComponent },
  { path: 'projetos', component: ProjetosComponent },
  { path: 'confections-showcase', component: ConfectionsShowcaseComponent },
  { path: 'laundry', component: LaundryComponent },
  { path: 'confections', component: ConfectionsComponent },
  { path: 'plastics-showcase', component: PlasticsShowcaseComponent },
  { path: 'laundry-showcase', component: LaundryShowcaseComponent },
  { path: 'plastics', component: PlasticsComponent },
  { path: 'cria', component: CriaComponent },
  { path: 'cria/didatica', component: DidaticaComponent },
  { path: 'cria/informacoes', component: CriaInformacoesComponent },
  { path: 'cria/resultados', component: CriaResultadosComponent },
  { path: 'pesquisadores', component: PesquisadoresComponent },
  { path: 'linhas-de-pesquisa', component: LinhasDePesquisaComponent },
  { path: 'events', component: EventsComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'biblioteca', component: BibliotecaComponent },
  { path: 'cadastro', component: CadastroComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'new-password/:email/:token', component: NewPasswordComponent },
  {
    path: 'painel-pessoa-fisica',
    component: PainelPessoaFisicaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'painel-pessoa-juridica',
    component: PainelPessoaJuridicaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'cadastro-residuos',
    component: CadastroResiduosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'solicitantes-residuos',
    component: SolicitantesResiduosComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
